var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-white h-screen"},[_c('div',{staticClass:"bg-lightGray px-2 sm:px-20"},[_c(_setup.CtaSection,{staticClass:"max-w-screen-xl mx-auto"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }